import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { InsightsPage } from './InsightsPage';

const searchSchema = z.object({
  month: z.string().optional(),
});

export const Route = createFileRoute('/_protected/_consumer/insights/')({
  component: InsightsPage,
  validateSearch: searchSchema,
});
